// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 15) return "./default/chunk-article-listed.a3fa1fb92f51b2531225.js";
	if (chunkId === 36) return "./default/chunk-subscription.797025e0e087bac38890.js";
	if (chunkId === 64) return "./64.94c554867b5973bcb995.js";
	if (chunkId === 34) return "./default/chunk-small-gallery.8a57468fdbb5a677cf01.js";
	if (chunkId === 30) return "./default/chunk-photo-credit-toogle.938ff555b10404450864.js";
	if (chunkId === 35) return "./default/chunk-social-click.920afef4b0979a579fde.js";
	if (chunkId === 38) return "./default/chunk-table.9967d554b75d4b8ab8dd.js";
	if (chunkId === 42) return "./default/gallery-in-art-preserve-scroll.e8ba9d4378e65331867b.js";
	if (chunkId === 65) return "./65.bfe9b4a5cc1acecf37a8.js";
	if (chunkId === 29) return "./default/chunk-online-reports.94cfbdd4550c3f84c926.js";
	if (chunkId === 5) return "./chunk-league-table.fb2ec26f18784ac0a0c2.js";
	// return url for filenames based on template
	return undefined;
};